var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        ref: "wrapRef",
        staticClass: "group-drop-tran over-hidden",
        on: { transitionend: _vm.onTransitionEnd },
      },
      [
        _c(
          "div",
          { ref: "unfoldRef" },
          _vm._l(_vm.data, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                class:
                  item.projectIntegrateType === 1
                    ? "set-group"
                    : "sub-content mb12",
                attrs: { div: "" },
              },
              [
                item.projectIntegrateType === 1
                  ? _c(
                      "Subproject-group",
                      {
                        staticClass: "mb12",
                        attrs: {
                          title: item.name,
                          num: item.project4IntegrateInfo.length,
                        },
                      },
                      _vm._l(item.project4IntegrateInfo, function (sItem) {
                        return _c("Subproject-item", {
                          key: sItem.id,
                          attrs: { data: sItem },
                        })
                      }),
                      1
                    )
                  : _c("Subproject-item", { attrs: { data: item } }),
              ],
              1
            )
          }),
          0
        ),
      ]
    ),
    _c("div", { staticClass: "more font-size-14" }, [
      _c(
        "div",
        {
          staticClass: "inline-center cursor-p text-no-select",
          on: { click: _vm.resizeHeight },
        },
        [
          _c("span", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("biz_pc_expand_more" /** 展开更多 */)) +
                "\n      "
            ),
          ]),
          _c("yxt-svg", {
            staticClass: "ml6",
            attrs: {
              "icon-class": _vm.checkStatus ? "arrow_down" : "arrow_up",
              width: "12px",
              height: "12px",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }